export default "__VITE_ASSET__CCaELtgK__"